import React, { useEffect, useState } from "react";
import {
  Loading,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
  Form,
  Row,
  Column,
  TextInput,
  Button,
} from "carbon-components-react";
import { DataViewAlt24, Download24, Search32 } from "@carbon/icons-react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import Card from "../../components/Card/Card";
import http from "../../http-common";

const tableHeaders = [
  { header: "Empresa", key: "name" },
  { header: "NUIT", key: "nuit" },
  { header: "Nº de Pontuações", key: "scoredByCount" },
  { header: "Pontuação Média", key: "averageScore" },
  { header: " ", key: "actions" },
];

const getCellContent = (cell, rowId) => {
  if (cell.info.header === "actions") {
    return (
      <Link to={`../prototype/${rowId}`} title="Ver Protótipo">
        <DataViewAlt24 />
      </Link>
    );
  }
  return cell.value;
};

const RankingPrototypesPage = () => {
  const [prototypes, setPrototypes] = useState([]);
  const [filteredPrototypes, setFilteredPrototypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { register, handleSubmit } = useForm();

  const fetchData = async () => {
    try {
      const response = await http.get("/prototypes/ranking");
      const data = response.data.map((p) => ({
        id: p.uuid,
        name: p.companyName,
        nuit: p.nuit,
        scoredByCount: p.scoredByCount || 0,
        averageScore:
          p.averageScore == null
            ? "Não Pontuado"
            : p.averageScore.toFixed(2),
        platformUrl: p.platformUrl,
      }));
      setPrototypes(data);
      setFilteredPrototypes(data);
    } catch (error) {
      toast.error("Erro ao carregar ranking de protótipos");
    } finally {
      setIsLoading(false);
    }
  };

  const onSearch = (data) => {
    if (!data.companyName) {
      setFilteredPrototypes(prototypes);
      return;
    }
    const filtered = prototypes.filter((p) =>
      p.name.toLowerCase().includes(data.companyName.toLowerCase())
    );
    setFilteredPrototypes(filtered);
  };

  const downloadExcel = () => {
    const excelData = filteredPrototypes.map((p) => ({
      "Nome da Empresa": p.name,
      NUIT: p.nuit,
      "Nº de Pontuações": p.scoredByCount,
      "Pontuação Média": p.averageScore,
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Ranking Protótipos");

    const currentDate = new Date().toISOString().split("T")[0];
    XLSX.writeFile(wb, `ranking-prototipos-${currentDate}.xlsx`);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Card title="Ranking de Protótipos">
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />

      <DataTable
        rows={filteredPrototypes}
        headers={tableHeaders}
        isSortable
        useZebraStyles
      >
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <TableToolbar aria-label="ranking prototypes toolbar">
              <TableToolbarContent>
                <Form
                  className="data-table-search-form"
                  onSubmit={handleSubmit(onSearch)}
                >
                  <Row>
                    <Column sm={6} md={8} lg={8}>
                      <TextInput
                        id="companyName"
                        labelText=""
                        placeholder="Nome da Empresa"
                        {...register("companyName")}
                      />
                    </Column>
                  </Row>
                  <Button type="submit" renderIcon={Search32}>
                    Pesquisar
                  </Button>
                </Form>
                <Button
                  kind="secondary"
                  renderIcon={Download24}
                  onClick={downloadExcel}
                  disabled={filteredPrototypes.length === 0}
                >
                  Exportar Excel
                </Button>
              </TableToolbarContent>
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader
                      {...getHeaderProps({ header })}
                      key={header.key}
                    >
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
    </Card>
  );
};

export default RankingPrototypesPage;
